import { useTheme } from "@mui/material/styles"
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useSettingsContext } from "../components/settings"

const useAlerts = () => {

    const theme = useTheme()
    const { themeMode } = useSettingsContext()
    const isLight = themeMode === 'light'
    const bgColorToast = isLight ? theme.palette.grey[200] : theme.palette.grey[800]

    const toastStyles = {
        background: bgColorToast, 
        color: theme.palette.text.primary
    }

    const toastConf = {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: `${ themeMode }`,
        style: { ...toastStyles },
    }

    const alertSuccess = (msg) => {
        toast.success( msg, toastConf )
    }

    const alertError = (msg) => {
        toast.error( msg, toastConf )
    }

    const alertWarning = (msg) => {
        toast.warn( msg, toastConf )
    }

    const alertInfo = (msg) => {
        toast.info( msg, toastConf )
    }

    const alertResponse = (ret) => {
        switch (ret?.type){
            case 'success':
                toast.success( ret.msg, toastConf )
            break;

            case 'error':
                toast.error( ret.msg, toastConf )
            break;

            case 'info':
                toast.info( ret.msg, toastConf )
            break;

            case 'warning':
                toast.warn( ret.msg, toastConf )
            break;

            default:
                toast( ret.msg, toastConf )
            break;
        }
    }

    const alertResponseOnError = (ret) => {
        if(ret?.code !== 200){
            alertError(ret?.msg || 'Error al procesar')
        }
    }

    return { 
        alertSuccess, alertError, alertWarning,
        alertInfo, alertResponse, alertResponseOnError
    }
}
export { useAlerts }